<template>
    <div class="md:w-11/12 w-full flex  sm:h-auto flex-wrap mx-auto shadow-xl bg-white p-2 ">

      <div class="w-full flex sm:w-11/12 mx-auto">
        <div class=" flex flex-row w-full">

          <div class="flex-1">
            <div class="w-max mx-auto sm:mx-0 relative">
              <a class=" cursor-pointer transition duration-500 ease-in-out   xs:flex items-center non-active" @click="updatecurrentActivityBookmark('activity')" v-bind:class="{'active': currentActivityBookmark === 'activity'}">
                <img class=" mx-auto  non-active md:my-1 sm:my-auto" src="/img/myle/svg/ic_NavMessages.svg" alt="">
                <span class="text-gray-400 pr-4 xs:block hidden text-center ">Activities</span>
                <span class="text-gray-400 text-sm xs:hidden block text-center ">Activities</span>
              </a>
            </div>
          </div>

          <div class="flex-1">
            <div class="w-max mx-auto relative">
              <a class="cursor-pointer transition duration-500 ease-in-out   xs:flex items-center non-active"  @click="updatecurrentActivityBookmark('notification')"  v-bind:class="{'active': currentActivityBookmark === 'notification'}">
                <img class=" mx-auto  non-active md:my-1 sm:my-auto" src="/img/myle/svg/ic_NavMessages.svg" alt="">
                <span class="text-gray-400 pr-4 xs:block hidden  text-center ">Notifications</span>
                <span class="text-gray-400 text-sm xs:hidden block text-center ">Notifications</span>
              </a>
            </div>
          </div>

          <div class="flex-1">
            <div class="w-max sm:float-right mx-auto sm:mx-0 relative">
              <a class=" cursor-pointer transition duration-500 ease-in-out   xs:flex items-center non-active" @click="updatecurrentActivityBookmark('message')" v-bind:class="{'active': currentActivityBookmark === 'message'}">
                <img class=" mx-auto  non-active md:my-1 sm:my-auto" src="/img/myle/svg/ic_NavMessages.svg" alt="">
                <span class="text-gray-400 pr-4 xs:block hidden text-center ">Messages</span>
                <span class="text-gray-400 text-sm xs:hidden block text-center ">Messages</span>
              </a>
            </div>
          </div>

        </div>
      </div>

    </div>
</template>
<script>
  import { mapMutations, mapState } from 'vuex';
  export default {
    name: "subActivityBar",
    data() {
      return {}
    },
    props: {},
    methods: {
      ...mapMutations('events', ['updatecurrentActivityBookmark']),
    },
    computed: {
      ...mapState('events', ['currentActivityBookmark']),
    }
  };
</script>
